export const getIsOdd = ({ gantt, task }, column) =>
  gantt?.oddColsConfig ? gantt.oddColsConfig[column] : false;

export const getIsOnlyReadElement = (onlyRead, task, subtradeRole) => {
  const gantt = window?.ganttVisualization || window?.to_use_react_gantt;
  const isGanttReadonly = gantt?.config?.readonly;

  return (
    onlyRead ||
    task.readonly ||
    isGanttReadonly ||
    (subtradeRole && subtradeRole.isSubtradeRole)
  );
};
